"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styled = exports.hexToRGB = void 0;
var hexToRGB_1 = require("./hexToRGB");
Object.defineProperty(exports, "hexToRGB", { enumerable: true, get: function () { return hexToRGB_1.hexToRGB; } });
var styled_1 = require("./styled");
Object.defineProperty(exports, "styled", { enumerable: true, get: function () { return styled_1.styled; } });
//# sourceMappingURL=index.js.map